export const places_data = [
  {
    place: "Air Port",
    key: "airport_distance",
  },
  {
    place: "Beach",
    key: "beach_distance",
  },
  {
    place: "Bus Stop",
    key: "bus_stop_distance",
  },
  {
    place: "Doctor",
    key: "doctor_medical_distance",
  },
  {
    place: "Night Life",
    key: "club_distance",
  },
  {
    place: "Restaurant",
    key: "restaurant_distance",
  },
  {
    place: "Shops",
    key: "shop_distance",
  },
  {
    place: "Town Center",
    key: "town_center_distance",
  },
  {
    place: "Water",
    key: "water_distance",
  },
  {
    place: "Golf",
    key: "golf_distance",
  },
  {
    place: "Railway Station",
    key: "railway_station_distance",
  },
  {
    place: "Ferry Port",
    key: "port_distance",
  },
];

export const additionalCosts = [
  { label: "Cleaning Fee", key: "cleaningCost" },
  { label: "Tourist Fee", key: "touristFee" },
  { label: "Refundable Security deposit", key: "securityDeposit" },
  { label: "Extra Price Per Guests", key: "extraCostPerGuest" },
  { label: "Heating Costs", key: "heatingCost" },
  { label: "Electricity Fee", key: "electricityFee" },
];

export const want_to = [
  {
    image: "want-1.webp",
    btn_text: "Publish",
  },
  {
    image: "want-2.webp",
    btn_text: "Book",
  },
];

export const Bedrooms = ["1", "2", "3", "4", "5", "5+"];

export const currency = [
  { code: "EUR", title: "EUR", symbol: "€" },
  { code: "USD", title: "USD", symbol: "$" },
  { code: "AED", title: "AED", symbol: "د.إ" },
  { code: "GBP", title: "GBP", symbol: "£" },
  { code: "AUD", title: "AUD", symbol: "A$" },
  { code: "BGN", title: "BGN", symbol: "лв" },
  { code: "CAD", title: "CAD", symbol: "C$" },
  { code: "CZK", title: "CZK", symbol: "Kč" },
  { code: "DKK", title: "DKK", symbol: "DKK" },
  { code: "EGP", title: "EGP", symbol: "E£" },
  { code: "HUF", title: "HUF", symbol: "Ft" },
  { code: "ISK", title: "ISK", symbol: "ISK" },
  { code: "NOK", title: "NOK", symbol: "NOK" },
  { code: "PLN", title: "PLN", symbol: "zł" },
  { code: "RON", title: "RON", symbol: "lei" },
  { code: "ZAR", title: "ZAR", symbol: "R" },
  { code: "SEK", title: "SEK", symbol: "SEK" },
];

export const howbook_points = [
  { point: "It's simple to make a Booking on", link: "www.therentalhive.com" },
  { point: "Look for properties with the 'Inquire Now' button." },
  { point: "Choose the dates you wish to travel and the number of guests." },
  { point: "Click on the Inquire Now' button." },
  { point: "Click 'Inquire Now'." },
  { point: "The inquiry goes to the owner." },
  {
    point:
      "The owner will revert you within 24-48 hours and you will have direct communication with them and book directly with owner and pays amount via Bank Transfer, Card, Paypal.",
  },
  { point: "Look for properties with the 'Inquire Now' button." },
];

export const advice_data = [
  { title: "High-Quality Photos " },
  { title: "Accurate Descriptions  " },
  { title: "Pricing Strategy " },
  { title: "Guest Communication  " },
  { title: "Manage Your Calendar " },
  { title: "Guest Reviews " },
];

export const iNeedHelp = [
  { label: "To Advertise my property" },
  { label: "To Book a property" },
  { label: "For Sales" },
  { label: "Create advert my property" },
  { label: "Special Offer for Multiple Properties" },
  { label: "Payment and Invoice" },
  { label: "Others" },
];

export const ratingLabels = [
  "Excellent",
  "Good",
  "Average",
  "Below Average",
  "Poor",
];

export const ratingCounts = [5, 4, 3, 2, 1];

export const successMsgStyle = {
  id: "",
  position: "top-center",
  loading: true,
  style: {
    padding: "9px",
    background:
      "linear-gradient(321deg, rgb(73 223 13 / 86%) 34%, rgb(6, 217, 14) 68%, rgb(76, 217, 6) 82%)",
    color: "#fff",

    fontSize: "14px",
    fontWeight: "600",
    width: "20%",
  },
  iconTheme: {
    primary: "#FFF",
    secondary: "#4a8d00",
  },
};

export const errorMsgStyle = {
  id: "",
  position: "top-center",
  loading: true,
  style: {
    padding: "9px",
    background:
      "linear-gradient(321deg, rgb(255 0 0 / 86%) 34%, rgb(255 0 0) 68%, rgb(255 0 0) 82%)",
    color: "#fff",

    fontSize: "14px",
    fontWeight: "600",
    width: "20%",
  },
  iconTheme: {
    primary: "#FFF",
    secondary: "#ff0101",
  },
};

export const warningMsgStyle = {
  id: "",
  position: "top-center",
  loading: true,
  style: {
    padding: "9px",
    background:
      "linear-gradient(321deg, rgb(255 141 0 / 86%) 34%, rgb(255 153 0) 68%, rgb(255 165 0) 82%)",
    color: "#fff",

    fontSize: "14px",
    fontWeight: "600",
    width: "20%",
  },
  iconTheme: {
    primary: "#FFF",
    secondary: "#ff8201",
  },
};

export const allowedImageExtensions = [
  ".jpg",
  ".jpeg",
  ".png",
  ".svg",
  ".webp",
  ".avif",
];

export const allowedVideoExtensions = [
  ".mp4",
  ".mov",
  ".avi",
  ".mkv",
  ".flv",
  ".wmv",
  ".webm",
  ".ogg",
  ".3gp",
  ".mpeg",
  "mp4",
  "mov",
  "avi",
  "mkv",
  "flv",
  "wmv",
  "webm",
  "ogg",
  "3gp",
  "mpeg",
];

export const allMonths = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "June",
  "July",
  "Aug",
  "Sept",
  "Oct",
  "Nov",
  "Dec",
];
export const bannerOptions = {
  loop: true, // Enables looping of the carousel
  margin: 0, // Space between items
  nav: false, // Shows navigation arrows
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
  autoplay: false, // Enables autoplay
  autoplayTimeout: 3000, // Autoplay delay (3 seconds)
  autoplayHoverPause: true, // Pauses on hover
};

export const statusArr = ["Publish", "UnPublish"];

export const activeStatusArr = ["Active", "Deactive"];
export const userroleArr = ["vendor", "customer"];

export const couponStatusArr = ["Active", "InActive"];
export const faqTypeArr = ["Homeowner", "Guest"];

export const discount_type = ["fixed", "percentage"]

export const TypeArr = ["percentage", "fixed"];

export const inquiryStatusArr = ["Pending", "Confirmed", "Cancelled"];
export const orderStatusArr = ["Success", "Pending", "Failed"];

export const approveArr = ["Approved", "Not Approved"];

export const planStatusArr = ["Expired", "Publish", "UnPublish"];

export const RegionTypes = ["State", "City"];

export const experience = {
  loop: false,
  margin: 0,
  nav: true,
  dots: false,
  autoplay: false,
  autoplaySpeed: 3000,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" width="7.171" height="13.965" viewBox="0 0 7.171 13.965">   <path id="fi-rr-angle-small-right" d="M9.986,9.879l4.589-4.586a1,1,0,0,1,1.411,1.414L11.4,11.293a1,1,0,0,0,0,1.414l4.586,4.586a1,1,0,1,1-1.415,1.414L9.986,14.121A3,3,0,0,1,9.986,9.879Z" transform="translate(-9.107 -5.035)" fill="#111111"/> </svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="7.171" height="13.965" viewBox="0 0 7.171 13.965"><path id="fi-rr-angle-small-right" d="M15.4,9.879,10.811,5.293A1,1,0,0,0,9.4,6.707l4.586,4.586a1,1,0,0,1,0,1.414L9.4,17.293a1,1,0,1,0,1.415,1.414L15.4,14.121A3,3,0,0,0,15.4,9.879Z" transform="translate(-9.107 -5.035)" fill="#111111"/></svg>',
  ],
  responsive: {
    0: { items: 1 },
    576: { items: 2 },
    768: { items: 3 },
    1000: { items: 4 },
    1200: { items: 4 },
  },
};

export const topListingExperience = {
  loop: false,
  margin: 0,
  nav: true,
  dots: false,
  autoplay: false,
  autoplaySpeed: 3000,
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" width="7.171" height="13.965" viewBox="0 0 7.171 13.965">   <path id="fi-rr-angle-small-right" d="M9.986,9.879l4.589-4.586a1,1,0,0,1,1.411,1.414L11.4,11.293a1,1,0,0,0,0,1.414l4.586,4.586a1,1,0,1,1-1.415,1.414L9.986,14.121A3,3,0,0,1,9.986,9.879Z" transform="translate(-9.107 -5.035)" fill="#111111"/> </svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="7.171" height="13.965" viewBox="0 0 7.171 13.965"><path id="fi-rr-angle-small-right" d="M15.4,9.879,10.811,5.293A1,1,0,0,0,9.4,6.707l4.586,4.586a1,1,0,0,1,0,1.414L9.4,17.293a1,1,0,1,0,1.415,1.414L15.4,14.121A3,3,0,0,0,15.4,9.879Z" transform="translate(-9.107 -5.035)" fill="#111111"/></svg>',
  ],
  responsive: {
    0: { items: 1 },
    576: { items: 2 },
    768: { items: 3 },
    1000: { items: 4 },
    1200: { items: 4 },
  },
};

export const RacinSlider = {
  loop: true,
  // margin: 0,
  nav: true,
  dots: false,
  animateIn: "fadeIn",
  animateOut: "fadeOut",
  navText: [
    '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none"> <path d="M2.28936 7.69471C2.10189 7.50718 1.99657 7.25288 1.99657 6.98771C1.99657 6.72255 2.10189 6.46824 2.28936 6.28071L6.87436 1.69471C7.05652 1.50611 7.15731 1.25351 7.15503 0.991311C7.15276 0.729114 7.04759 0.478302 6.86218 0.292894C6.67677 0.107485 6.42596 0.00231622 6.16376 3.78025e-05C5.90156 -0.00224062 5.64896 0.0985542 5.46036 0.280712L0.87836 4.86671C0.315947 5.42929 0 6.19222 0 6.98771C0 7.7832 0.315947 8.54613 0.87836 9.10871L5.46436 13.6947C5.65296 13.8769 5.90556 13.9777 6.16776 13.9754C6.42996 13.9731 6.68077 13.8679 6.86618 13.6825C7.05159 13.4971 7.15676 13.2463 7.15903 12.9841C7.16131 12.7219 7.06052 12.4693 6.87836 12.2807L2.28936 7.69471Z" fill="white"/></svg>',
    '<svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">  <path d="M5.71064 7.69471C5.89811 7.50718 6.00343 7.25288 6.00343 6.98771C6.00343 6.72255 5.89811 6.46824 5.71064 6.28071L1.12564 1.69471C0.943482 1.50611 0.842688 1.25351 0.844966 0.991311C0.847244 0.729114 0.952414 0.478302 1.13782 0.292894C1.32323 0.107485 1.57404 0.00231622 1.83624 3.78025e-05C2.09844 -0.00224062 2.35104 0.0985542 2.53964 0.280712L7.12164 4.86671C7.68405 5.42929 8 6.19222 8 6.98771C8 7.7832 7.68405 8.54613 7.12164 9.10871L2.53564 13.6947C2.34704 13.8769 2.09444 13.9777 1.83224 13.9754C1.57004 13.9731 1.31923 13.8679 1.13382 13.6825C0.948413 13.4971 0.843245 13.2463 0.840966 12.9841C0.838688 12.7219 0.939482 12.4693 1.12164 12.2807L5.71064 7.69471Z" fill="white"/>  </svg>',
  ],
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
};
